/**
 * 群相关
 */
import _ from 'lodash'
import createModel from 'utils/model'
import {getGroupMembers, getGroupDetail, getGroupGrouping, chatGroupsSearch} from 'services/group'

export default createModel({
    namespace: 'group',

    state: {
        groupMembersTableData: {},
        groupDetail: {},
    },

    effects: {
        *getGroupMembers({payload}, {select, put, call}) {
            const {groupMembersTableData} = yield select(({group}) => group)

            const newParams = {
                offset:
                    groupMembersTableData.pagination.pageSize *
                    (groupMembersTableData.pagination.current - 1),
                limit: groupMembersTableData.pagination.pageSize,
                ...groupMembersTableData.params,
            }

            const res = yield call(getGroupMembers, {id: payload.id, body: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.groupMembersTableData.dataSource = res.data
                    draft.groupMembersTableData.pagination.total = _.get(
                        res,
                        'pagination.rows_found',
                        0,
                    )
                },
            })
        },
        *getGroupDetail({payload}, {put, call}) {
            const res = yield call(getGroupDetail, payload)

            if (res.data) {
                yield put({
                    type: 'immerCb',
                    payload: (draft) => {
                        draft.groupDetail = res.data || {}
                    },
                })
            }
        },

        // 获取群分组
        *getGroupGrouping(xx, {call}) {
            return yield call(getGroupGrouping)
        },

        // 群
        *chatGroupsSearch({payload}, {call}) {
            return yield call(chatGroupsSearch, payload)
        },
    },
})
